import { createContext } from "react";
const OutletContext = createContext(undefined);
export default OutletContext;
